(function () {
  'use strict';

  function formatMoney(cents) {
    var value = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP',
        currencyDisplay: 'narrowSymbol',
        maximumFractionDigits: 2,
        minimumFractionDigits: 2
      }).format(value);
    } catch (e) {
      return '£' + value.toFixed(2);
    }
  }

  function init(section) {
    var productJson = section.querySelector('[data-product-json]');
    var form = section.querySelector('[data-product-form]');
    if (!productJson || !form) return;

    var variants;
    try {
      variants = JSON.parse(productJson.textContent || '[]');
    } catch (e) {
      return;
    }
    if (!Array.isArray(variants)) return;

    function getVariant() {
      var input = form.querySelector('input[name="id"]');
      var id = input ? String(input.value || '') : '';
      return variants.find(function (variant) {
        return String(variant.id || '') === id;
      });
    }

    function getStorageAddOn() {
      var b = section.querySelector('[data-storage-option].is-selected, [data-storage-option][aria-pressed="true"]');
      if (!b) return { price: 0, compare: 0 };
      return {
        price: Number(b.dataset.storagePrice || 0),
        compare: Number(b.dataset.storageComparePrice || 0)
      };
    }

    function getServiceTotal() {
      var total = 0;
      section.querySelectorAll('[data-service-option].is-selected, [data-service-option][aria-pressed="true"]').forEach(function (b) {
        total += Number(b.dataset.servicePrice || 0);
      });
      return total;
    }

    function update() {
      var variant = getVariant();
      if (!variant) return;

      var basePrice = Number(variant.price || 0);
      var baseCompare = Number(variant.compare_at_price || variant.compareAtPrice || 0);

      // The displayed price must include the selected storage + service add-ons.
      // Previously this wrote only the base variant price, which silently undid
      // the storage add-on price after every storage click.
      var storage = getStorageAddOn();
      var service = getServiceTotal();
      var price = basePrice + storage.price + service;
      var compare = baseCompare + storage.compare;
      var showCompare = compare > price;

      section.querySelectorAll('[data-price], [data-sticky-price]').forEach(function (node) {
        node.textContent = formatMoney(price);
      });

      section.querySelectorAll('[data-compare-price]').forEach(function (node) {
        node.textContent = showCompare ? formatMoney(compare) : '';
      });

      section.querySelectorAll('[data-compare-wrap]').forEach(function (node) {
        node.hidden = !showCompare;
      });

      section.querySelectorAll('[data-price-save]').forEach(function (node) {
        node.textContent = showCompare ? 'Save ' + Math.round(((compare - price) * 100) / compare) + '%' : '';
      });

      // vfix base price stays the variant base (used by the server-side-nav
      // fallback), not the add-on-inclusive total.
      section.dataset.vfixBasePrice = String(basePrice);
      section.dataset.vfixBaseComparePrice = baseCompare > basePrice ? String(baseCompare) : '';
    }

    function schedule() {
      update();
      window.setTimeout(update, 80);
      window.setTimeout(update, 250);
      window.setTimeout(update, 700);
    }

    form.addEventListener('input', schedule);
    form.addEventListener('change', schedule);
    section.addEventListener('variant:change', schedule);
    section.addEventListener('click', function (event) {
      if (event.target.closest('[data-option-value], [data-option-value-id], [data-storage-option], [data-button-option]')) {
        schedule();
      }
    }, true);

    schedule();
  }

  function initAll() {
    document.querySelectorAll('[data-product-section]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
